import axios from "axios";
import { API_HOST } from "@/core/variables";

class DeployRepository {
    find = async (scenarioId: string, page?: number, size?: number) => {
        return axios
            .get(`${API_HOST}/scenario/${scenarioId}/deploy`, {
                params: {
                    page: page,
                    size: size
                }
            })
            .then((response) => Promise.resolve(response.data))
            .catch((error) => Promise.reject(error));
    };

    read = async (scenarioId: string, deploy_id: string) => {
        return axios
            .get(`${API_HOST}/scenario/${scenarioId}/deploy/${deploy_id}`)
            .then((response) => Promise.resolve(response.data))
            .catch((error) => Promise.reject(error));
    };

    getDiff = async (scenarioId: string, deploy_id: string) => {
        return axios
            .get(`${API_HOST}/scenario/${scenarioId}/deploy/diff`, {
                params: {
                    deploy_id
                }
            })
            .then((response) => Promise.resolve(response.data))
            .catch((error) => Promise.reject(error));
    };

    deploy = async (scenarioId: string, version: string, description?: string) => {
        return axios
            .post(`${API_HOST}/scenario/${scenarioId}/deploy`, {
                version,
                description
            })
            .then((response) => Promise.resolve(response.data))
            .catch((error) => Promise.reject(error));
    };

    restore = async (scenarioId: string, deploy_id: string, description?: string) => {
        return axios
            .post(`${API_HOST}/scenario/${scenarioId}/restore`, {
                deploy_id,
                description
            })
            .then((response) => Promise.resolve(response.data))
            .catch((error) => Promise.reject(error));
    };
}

const deployRepository = new DeployRepository();

export default deployRepository; 